import { render, staticRenderFns } from "./RolesPermissionsSettings.vue?vue&type=template&id=0b28730a&"
import script from "./RolesPermissionsSettings.vue?vue&type=script&lang=js&"
export * from "./RolesPermissionsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports